import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { OtherCoreBusinessActivities } from 'src/app/store/feature-stores/classification-search-store/models/classification-unit';
import { Subscription } from 'rxjs';
import { ErrorMessage } from 'src/app/shared/reactive-validators/error.message';
import * as fieldValidators from 'src/app/shared/reactive-validators/fields.validator';
import { FormFunctions } from '../../../form-functions';
import { EligibilityE2E } from 'src/app/store/feature-stores/business-details-store/models/eligibility';

@Injectable()
export class OtherCoreBusinessActivitiesFunctions {
  subscriptions: Subscription[] = [];  
 
  clickSearchButtonToProceedErrorMessage = 'Please click the \'Search\' button to proceed.';
 
  numberOfModel = 0;
  leaseVehicle = 'Lease';
  ownVehicle = 'Own'; 

  modelTooltipMessage:string = 'For example, Honda Civic, Ford F-150, Toyota RAV4, Peterbilt 359, etc.';
  selectCuDesc = ''; 
 
  listModelYearDetails = [   
    { id: 1, model: 'model1', year: 'year1' },
    { id: 2, model: 'model2', year: 'year2' },
    { id: 3, model: 'model3', year: 'year3' }
  ];

  private model1Fields = {
    model1: new UntypedFormControl('', [fieldValidators.requiredValidator(ErrorMessage.classificationSearchModelValidation.emptyMsg)]),
    year1: new UntypedFormControl('', [fieldValidators.yearValidator(ErrorMessage.classificationSearchYearValidation.emptyMsg,4,ErrorMessage.classificationSearchYearValidation.validYearMsg)])
  }

  private model2Fields = {
    model2: new UntypedFormControl('', [fieldValidators.requiredValidator(ErrorMessage.classificationSearchModelValidation.emptyMsg)]),
    year2: new UntypedFormControl('', [fieldValidators.yearValidator(ErrorMessage.classificationSearchYearValidation.emptyMsg,4,ErrorMessage.classificationSearchYearValidation.validYearMsg)])
  }

  private model3Fields = {
    model3: new UntypedFormControl('', [fieldValidators.requiredValidator(ErrorMessage.classificationSearchModelValidation.emptyMsg)]),
    year3: new UntypedFormControl('', [fieldValidators.yearValidator(ErrorMessage.classificationSearchYearValidation.emptyMsg,4,ErrorMessage.classificationSearchYearValidation.validYearMsg)])
  }

  //new field in REG2.0
  private businessOwnVehicleAtEndOfLeaseFields = {
    vehicleLeasingFirmName: new UntypedFormControl('', [fieldValidators.requiredValidator(ErrorMessage.classificationSearchLeaseVehicle.emptyMsg,4,ErrorMessage.classificationSearchLeaseVehicle.validMsg)]),
    businessOwnVehicleAtEndOfLease: new UntypedFormControl('')
  }

  private otherCoreBusinessActivitiesFields = {  
    driveToOtherProvince: new UntypedFormControl(''),
    vehicleOwnedOrLeased: new UntypedFormControl('')   
  };

  private contractOutCoreActivitiesFields = {  
    contractOutCoreActivities: new UntypedFormControl('', [Validators.required])
  };
  
  constructor(     
    private formFunctions: FormFunctions) {  }

  public createOtherCoreBusinessActivitiesForm(formGroup: UntypedFormGroup) {   
    try {

      this.formFunctions.addFormFields(this.contractOutCoreActivitiesFields, formGroup);      
    } catch(ex) {
      console.log('[OtherCoreBusinessActivitiesFunctions] createOtherCoreBusinessActivitiesForm ex=' + ex.message);
    }    
  }  


  public unsubscribeAll() {    
    try {
      if (this.subscriptions && this.subscriptions.length > 0) {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
      }     

    } catch(ex) {
      console.log('[OtherCoreBusinessActivitiesFunctions] unsubscribeAll ex=' + ex.message);
    }  
  }
  
  
  public setFormValue(formGroup: UntypedFormGroup, name: string, value: any, caller?: string) {    
    try{     
      let control = formGroup.get(name);
      if (control) {
        control.setValue(value); 
      }      
    } catch(ex) { 
      console.log('[OtherCoreBusinessActivitiesFunctions] setFormValue formGroup=' + formGroup + ' name=' + name + ' caller=' + caller + ' ex=' + ex.message);
    }        
  } 

  private getFormControlValue(control: any) {    
    let value = control?.value;
    if (value == null || value == undefined) {
      value = '';
    }

    value = value.trim();
    return value;
  }  

  updateVehicleOwnedOrLeased(value: string, formGroup: UntypedFormGroup) {    
    console.log('[OtherCoreBusinessActivities] updateVehicleOwnedOrLeased value=' + value); 
    if (value === this.leaseVehicle) {
      this.formFunctions.addFormFields(this.businessOwnVehicleAtEndOfLeaseFields, formGroup); 
    } else {
      this.formFunctions.removeFormFields(this.businessOwnVehicleAtEndOfLeaseFields, formGroup); 
    }
  } 

  cuChangedHandler(classId: any, oldClasssId: any, internetRegistration: any, formGroup: UntypedFormGroup, isVehicleCu: boolean) {    
    let message = '[OtherCoreBusinessActivities] cuChangedHandler message= isVehicleCu=' + isVehicleCu + ', classId=' + classId + ' oldClasssId=' + oldClasssId;   
    try {            
      if (classId != null && classId === oldClasssId && internetRegistration != null) {    
        this.initContractOutCoreActivitiesFormGroupFromIReg(internetRegistration, formGroup);         
      } else {
        message = message + ', clean contractOutCoreActivities';
        formGroup.controls.contractOutCoreActivities?.setValue(null);   
        formGroup.controls.contractOutCoreActivities?.markAsUntouched();
        formGroup.controls.contractOutCoreActivities?.reset(); //reset contractOutCoreActivities
      }
      formGroup.controls.contractOutCoreActivities?.updateValueAndValidity();

      let listConstrols = []; 
      listConstrols.push({name: 'driveToOtherProvince', value:''});
      listConstrols.push({name: 'vehicleOwnedOrLeased', value:''});
      this.listModelYearDetails.forEach((item) => {
        listConstrols.push({name: item.year, value:''});
        listConstrols.push({name: item.model, value:''});
      });
      this.clearFormValues(listConstrols, formGroup);

      if (classId != null && isVehicleCu) {   
        this.numberOfModel = 1; //reset number of model to 1     
        this.formFunctions.addFormFields(this.otherCoreBusinessActivitiesFields, formGroup); 
        this.formFunctions.addFormFields(this.model1Fields, formGroup);      
        if (classId === oldClasssId && internetRegistration != null) {      
          this.initVehicleCuFormGroupFromIReg(internetRegistration, formGroup); 
        }
      } else {    
        this.numberOfModel = 0; //reset number of model to 1  
        this.formFunctions.removeFormFields(this.otherCoreBusinessActivitiesFields, formGroup); 
        this.formFunctions.removeFormFields(this.businessOwnVehicleAtEndOfLeaseFields, formGroup); 
        this.formFunctions.removeFormFields(this.model1Fields, formGroup);  
        this.formFunctions.removeFormFields(this.model2Fields, formGroup);  
        this.formFunctions.removeFormFields(this.model3Fields, formGroup);   
        message = message + ', clean form';
      }
     
      console.log( message);      
    }
    catch(ex) {
      console.log( message + ', ex=' + ex.message);
    }   
  }  
 
  clearFormValues(listConstrols: any, formGroup: UntypedFormGroup) {   
    try {         

      listConstrols.forEach((item) => {      
        const control = formGroup.get(item.name);
        control?.setValue(item.value);
        control?.markAsTouched();
        control?.reset();
      });
    
    }
    catch(ex) {
      console.log(' clearFormValues ex=' + ex.message);
    } 
  }

  private initContractOutCoreActivitiesFormGroupFromIReg(iReg: any, formGroup: UntypedFormGroup) {
    try {
      if (iReg != null) {
        const eligibility: EligibilityE2E = iReg.eligibility;
        if (eligibility.eligibilityResponseBusinessOperation) {
          const contractOutCoreActivities = iReg.contractOutCoreActivities; 
          this.setFormValue(formGroup, 'contractOutCoreActivities', contractOutCoreActivities);    
        } 
      }        
    }
    catch(ex) {
      console.log('initContractOutCoreActivitiesFormGroupFromIReg ex=' + ex.message);
    }      
  }


  private initVehicleCuFormGroupFromIReg(iReg: any, formGroup: UntypedFormGroup) {
    try{
      const eligibility: EligibilityE2E = iReg?.eligibility;

      if (eligibility != null && eligibility.eligibilityResponseBusinessOperation) {        
        const truckingOtherProvinceIndicator = eligibility.eligibilityResponseBusinessOperation.truckingOtherProvinceIndicator;
        const vehicleOwnershipDescriptionText = eligibility.eligibilityResponseBusinessOperation.vehicleOwnershipDescriptionText;        
        const vehicleLeasingFirmName = eligibility.eligibilityResponseBusinessOperation.vehicleLeasingFirmName;       

        formGroup.controls.vehicleOwnedOrLeased.setValue(vehicleOwnershipDescriptionText); 
        this.updateVehicleOwnedOrLeased(vehicleOwnershipDescriptionText, formGroup);       
        this.setFormValue(formGroup, 'driveToOtherProvince', truckingOtherProvinceIndicator);
        this.setFormValue(formGroup, 'vehicleOwnedOrLeased', vehicleOwnershipDescriptionText);        
        this.setFormValue(formGroup, 'vehicleLeasingFirmName', vehicleLeasingFirmName); 
        this.setFormValue(formGroup, 'businessOwnVehicleAtEndOfLease', iReg.businessOwnVehicleAtEndOfLease);  //new field

        const businessVehicleDescriptionText = eligibility.eligibilityResponseBusinessOperation.businessVehicleDescriptionText;
        let businessVehicleArray = businessVehicleDescriptionText !=null ? businessVehicleDescriptionText.split('^'): null;  
        if (businessVehicleArray != null && businessVehicleArray.length == 6) {    
          this.setFormValue(formGroup, 'model1', businessVehicleArray[0]);
          this.setFormValue(formGroup, 'year1', businessVehicleArray[1]);

          if (businessVehicleArray[2] != null && businessVehicleArray[2] != '') {
            this.addNewModelOrYear(formGroup);
            this.setFormValue(formGroup, 'model2', businessVehicleArray[2]);
            this.setFormValue(formGroup, 'year2', businessVehicleArray[3]);
          }
          if (businessVehicleArray[4] != null && businessVehicleArray[4] != '') {
            this.addNewModelOrYear(formGroup);
            this.setFormValue(formGroup, 'model3', businessVehicleArray[4]);
            this.setFormValue(formGroup, 'year3', businessVehicleArray[5]);
          }          
        }          
      }      
    }
    catch(ex) {
      console.log('initVehicleCuFormGroupFromIReg ex=' + ex.message);
    }      
  }  
 
  public getOtherCoreBusinessActivitiesInfoPayload(classId: any, formGroup: UntypedFormGroup, isVehicleCu: boolean): OtherCoreBusinessActivities {   
   
    try {
      let contractOutCoreActivities = '';
      let driveToOtherProvince = '';
      let vehicleOwnedOrLeased = '';
      let vehicleLeasingFirmName = '';
      let businessOwnVehicleAtEndOfLease = '';
      let model1 = '';
      let year1 = '';
      let model2 = '';
      let year2 = '';
      let model3 = '';
      let year3 = '';

      if (classId > 0 ) {
        contractOutCoreActivities = this.getFormControlValue(formGroup.controls.contractOutCoreActivities);
      }   
     
      if (isVehicleCu) {       
        driveToOtherProvince = this.getFormControlValue(formGroup.controls.driveToOtherProvince);
        vehicleOwnedOrLeased = this.getFormControlValue(formGroup.controls.vehicleOwnedOrLeased);
        vehicleLeasingFirmName = vehicleOwnedOrLeased === this.leaseVehicle? this.getFormControlValue(formGroup.controls.vehicleLeasingFirmName): '';
        businessOwnVehicleAtEndOfLease = this.getFormControlValue(formGroup.controls.businessOwnVehicleAtEndOfLease); //new field 
        model1 = this.getFormControlValue(formGroup.controls.model1);
        year1 = this.getFormControlValue(formGroup.controls.year1);
        model2 = this.getFormControlValue(formGroup.controls.model2);
        year2 = this.getFormControlValue(formGroup.controls.year2);
        model3 = this.getFormControlValue(formGroup.controls.model3);
        year3 = this.getFormControlValue(formGroup.controls.year3);     
      }

      //isVehicleCoreOperation will update eligibility.eligibilityResponseBusinessOperation.truckingCourierServiceIndicator; 
      const isVehicleCoreOperation = isVehicleCu ? 'Y' : 'N';
      
      const otherCoreBusinessActivitiesInfoPayload = {
        contractOutCoreActivities: contractOutCoreActivities,
        isVehicleCoreOperation: isVehicleCoreOperation,    
        driveToOtherProvince: driveToOtherProvince,
        vehicleOwnedOrLeased: vehicleOwnedOrLeased,
        vehicleLeasingFirmName: vehicleLeasingFirmName,
        businessOwnVehicleAtEndOfLease: businessOwnVehicleAtEndOfLease,    
        model1: model1,
        year1: year1,
        model2: model2,
        year2: year2,
        model3: model3,
        year3: year3      
      }; 
     return otherCoreBusinessActivitiesInfoPayload;   
   } catch(ex) { 
     console.log('getOtherCoreBusinessActivitiesInfoPayload ex=' + ex.message);
   } 
   return {};
 }  

 
 addNewModelOrYear(formGroup: UntypedFormGroup){
  if (this.numberOfModel <= 3){
    this.numberOfModel++;
    try { 
      if (this.numberOfModel ===2) {
        this.formFunctions.addFormFields(this.model2Fields, formGroup); 
      }

      if (this.numberOfModel ===3) {
        this.formFunctions.addFormFields(this.model3Fields, formGroup); 
      }
    } catch(ex) {
      console.log('[OtherCoreBusinessActivities] addNewModelOrYear ex=' + ex.message);
    } 
  }  
}

 removeModelAndYear(index: number, formGroup: UntypedFormGroup) {
  try {
    if (index >=1) {       
      this.setFormValue(formGroup, 'model' + index, '');
      this.setFormValue(formGroup, 'year' + index, '');        
      try { 
        if (index ===2) {
          this.formFunctions.removeFormFields(this.model2Fields, formGroup); 
        }

        if (index ===3) {
          this.formFunctions.removeFormFields(this.model3Fields, formGroup); 
        }
      } catch(ex) {
        console.log('[OtherCoreBusinessActivities] removeModelAndYear ex=' + ex.message);
      } 

      this.numberOfModel = index -1;
    }   
  } catch(ex){
    console.log('removeModelAndYear ex=' + ex.message);
  }   
}  


 showSelectCuDesc(isSearchButtonClicked: boolean) {
  let show = false;
  if (this.selectCuDesc != null && this.selectCuDesc != '' && isSearchButtonClicked) {
    show =  true;
  }   
  return show;
}
}
